import * as eHubApi from "./data.service";

export function getMiscReport(req) {
  return eHubApi.post_file("/api/report/misc", req);
}

export function getStandardReport(req) {
  return eHubApi.post_file("/api/report/standard", req);
}

export function getTradeReturnReport(req) {
  return eHubApi.post_file("/api/report/trade-return", req);
}

export function getPickslipReport(req) {
  return eHubApi.post_file("/api/report/pickslip", req);
}

export function getPutawayReport(req) {
  return eHubApi.post_file("/api/report/putaway", req);
}
export function getDeliveryOrderReport(req) {
  return eHubApi.post_file("/api/report/delivery-order", req);
}

export function getManifestReport(req){
  return eHubApi.post_file("/api/report/manifest", req);
}

export function getWaveReport(req){
  return eHubApi.post_file("/api/report/wavepickslip-sortinglist", req);
}
export function getEngravingReport(req){
  return eHubApi.post_file("/api/report/engraving-info", req);
}
export function getPutawayCancelReport(req) {
  return eHubApi.post_file("/api/report/putaway-cancel", req);
}



export function getRecvCodeOption(req) {
  return eHubApi.get(`/api/report/recv/options?customerCode=${req.customerCode}&recvType=${req.recvType}`);
}

export function getPickslipNumberOption(req) {
  return eHubApi.get(`/api/report/pickslip/options?customerCode=${req.customerCode}`);
}

export function getPutawayNumberOption(req) {
  return eHubApi.get(`/api/report/putaway/options?customerCode=${req.customerCode}`);
}
export function getDONumberOption(req) {
  return eHubApi.get(`/api/report/delivery-order/options?customerCode=${req.customerCode}`);
}
export function getCustOrdNbrOption(req) {
  return eHubApi.get(`/api/report/putaway-cancel/options?customerCode=${req.customerCode}`);
}

// enquiry

export function getSKUMovementEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/sku-movements?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getDivisionMovementEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/division-movements?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getDivisionGRNEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/division-grn?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getStockInventoryEnquiry(req){
  return eHubApi.get(`/api/multitenant/stock-inventories?customers=` + req.customers.join('&customers='));
}

// ALL CUSTOMER mode: backend returns an .xlsx file instead of a JSON list.
export function exportStockInventoryAllCustomer(){
  return eHubApi.get(`/api/multitenant/stock-inventories?customers=ALL CUSTOMER`, {
    responseType: 'blob',
  });
}

export function getOrderDetailsStatusEnquiry(req){
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  query.push(`type=${req.type}`);
  const custOrdNbrs = req.custOrdNbrs.split(',', 10).map(x => x.trim()).join("&custOrdNbrs=");
  if (Boolean(custOrdNbrs) && Boolean(custOrdNbrs.length))query.push(`custOrdNbrs=` + custOrdNbrs)
  if (req.startDate) query.push(`startDate=${req.startDate}`);
  if (req.endDate) query.push(`endDate=${req.endDate}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/enquiry/v2/order-details?${queryString}`);
}

// This endpoint is ALL CUSTOMER-only - it always returns an .xlsx file. custOrdNbrs is not
// supported here - it's ignored by the backend when fanned out across every customer's database.
export function exportOrderDetailsAllCustomer(req){
  return eHubApi.get(`/api/multitenant/order-details?type=${req.type}&startDate=${req.startDate}&endDate=${req.endDate}`, {
    responseType: 'blob',
  });
}

// export function getAgingReportEnquiry(req){
//   if (Boolean(req.customers.length)){
//     return eHubApi.get(`/api/enquiry/aging-report?customerCode=${req.customerCode}&customers=` + req.customers.join('&customers='));
//   }
//   return eHubApi.get(`/api/enquiry/aging-report?customerCode=${req.customerCode}`)
// }

export function getAgingReportEnquiry(req){
  if (Boolean(req.customers.length)){
    return eHubApi.get(`/api/enquiry/v2/aging?customerCode=${req.customerCode}&customers=` + req.customers.join('&customers='));
  }
  return eHubApi.get(`/api/enquiry/v2/aging?customerCode=${req.customerCode}`)
}

export function getPOReceivingEnquiry(req){
  return eHubApi.get(`/api/enquiry/po-receiving?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getShelfLifeReportEnquiry(req){
  return eHubApi.get(`/api/multitenant/shelf-life?type=${req.type}&customers=` + req.customers.join('&customers='));
}

// ALL CUSTOMER mode: backend returns an .xlsx file instead of a JSON list.
export function exportShelfLifeAllCustomer(req){
  return eHubApi.get(`/api/multitenant/shelf-life?type=${req.type}&customers=ALL CUSTOMER`, {
    responseType: 'blob',
  });
}

export function getGRNReportEnquiry(req){
  return eHubApi.get(`/api/enquiry/grn-report?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

// This endpoint is ALL CUSTOMER-only - it always returns an .xlsx file.
export function exportGRNReportAllCustomer(req){
  return eHubApi.get(`/api/multitenant/grn-report?startDate=${req.startDate}&endDate=${req.endDate}`, {
    responseType: 'blob',
  });
}

export function getAdjustmentEnquiry(req){
  return eHubApi.get(`/api/multitenant/adjustment?startDate=${req.startDate}&endDate=${req.endDate}&customers=` + req.customers.join('&customers='));
}

// ALL CUSTOMER mode: backend returns an .xlsx file instead of a JSON list.
export function exportAdjustmentAllCustomer(req){
  return eHubApi.get(`/api/multitenant/adjustment?startDate=${req.startDate}&endDate=${req.endDate}&customers=ALL CUSTOMER`, {
    responseType: 'blob',
  });
}

export function getTransferEnquiry(req){
  return eHubApi.get(`/api/enquiry/transfer?customerCode=${req.customerCode}&type=${req.type}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getStockHoldEnquiry(req){
  return eHubApi.get(`/api/enquiry/stock-hold?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getStockAttributesEnquiry(req){
  return eHubApi.get(`/api/enquiry/stock-attributes?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getPickslipEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/pickslips?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getPickslipPickScanEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/pick-scans?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getPickslipPackScanEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/pack-scans?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getLAHistEnquiry(req){
  return eHubApi.get(`/api/enquiry/la-hist?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getLAHistSummary(req){
  return eHubApi.post(`/api/enquiry/la-hist-summary`, req)
}

export function getSKUBarcodeEnquiry(req){
  return eHubApi.get(`/api/enquiry/skubarcode?customerCode=${req.customerCode}&active=${req.active}`)
}

export function getPhysicalCountEnquiry(req){
  return eHubApi.get(`/api/enquiry/physical-count?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getCycleCountEnquiry(req){
  return eHubApi.get(`/api/enquiry/cycle-count?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getSerialNumberEnquiry(req){
  return eHubApi.get(`/api/enquiry/recv-serial-no?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getLoadManifestEnquiry(req){
  return eHubApi.get(`/api/enquiry/load-manifest?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

//email

export function getOrderTrackingEnquiry(req){
  return eHubApi.get(`/api/multitenant/order-tracking-number?startDate=${req.startDate}&endDate=${req.endDate}&customers=` + req.customers.join('&customers='));
}

// ALL CUSTOMER mode: backend returns an .xlsx file instead of a JSON list.
export function exportOrderTrackingAllCustomer(req){
  return eHubApi.get(`/api/multitenant/order-tracking-number?startDate=${req.startDate}&endDate=${req.endDate}&customers=ALL CUSTOMER`, {
    responseType: 'blob',
  });
}

export function getBillingChargeableEnquiry(req){
  return eHubApi.get(`/api/enquiry/billing-chargeable?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}&viewPricePermission=${req.viewPricePermission}`)
}

export function getBillingInvoiceEnquiry(req){
  return eHubApi.get(`/api/enquiry/billing-invoice?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}&invoiceNumber=${req.invoiceNumber}&viewPricePermission=${req.viewPricePermission}`,{
    responseType: 'blob',
  });
}

export function sendEmail(req){
  return eHubApi.post(`/api/enquiry/send-email`, req);
}

export function exportExcel(req){
  return eHubApi.post(`/api/enquiry/export`, req);
}

export function sendEmail2(req){
  return eHubApi.post(`/api/enquiry/send-email2`, req);
}

export function getDivisionStockAdjustmentEnquiry(req){
  return eHubApi.get(`/api/enquiry/division-stock-adjustment?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

// summary

export const getOrderDetailsSummary = (req) => {
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  query.push(`type=${req.type}`);
  const custOrdNbrs = req.custOrdNbrs.split(',', 10).map(x => x.trim()).join("&custOrdNbrs=");
  if (Boolean(custOrdNbrs) && Boolean(custOrdNbrs.length))query.push(`custOrdNbrs=` + custOrdNbrs)
  if (req.startDate) query.push(`startDate=${req.startDate}`);
  if (req.endDate) query.push(`endDate=${req.endDate}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/enquiry/v2/order-summaries?${queryString}`)
}

// This endpoint is ALL CUSTOMER-only - it always returns an .xlsx file. custOrdNbrs is not
// supported here - it's ignored by the backend when fanned out across every customer's database.
export function exportOrderSummariesAllCustomer(req){
  return eHubApi.get(`/api/multitenant/order-summaries?type=${req.type}&startDate=${req.startDate}&endDate=${req.endDate}`, {
    responseType: 'blob',
  });
}

export function getRecvWorkEnquiry(req){
  const query = [];
  query.push(`customerCode=${req.customerCode}`);
  if (req.type) query.push(`type=${req.type}`);
  if (req.startDate) query.push(`startDate=${req.startDate}`);
  if (req.endDate) query.push(`endDate=${req.endDate}`);
  if (req.customers) query.push(`customers=${req.customers.join('&customers=')}`);
  const queryString = query.join("&");
  return eHubApi.get(`/api/enquiry/v2/recv-work?${queryString}`);
}

export function getEmptyLocationEnquiry(req){
  if (Boolean(req.customers.length)){
    return eHubApi.get(`/api/enquiry/v2/empty-location?customerCode=${req.customerCode}&customers=` + req.customers.join('&customers='));
  }
  return eHubApi.get(`/api/enquiry/v2/empty-location?customerCode=${req.customerCode}`)
}

export function getReturnOrderScanEnquiry(req){
  if (Boolean(req.customers.length)){
    return eHubApi.get(`/api/enquiry/v2/return-order-scan?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}&customers=` + req.customers.join('&customers='));
  }
  return eHubApi.get(`/api/enquiry/v2/return-order-scan?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getPutawayCancelEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/putaway-cancel?customerCode=${req.customerCode}&startDate=${req.startDate}&endDate=${req.endDate}`)
}

export function getInterDivisionInventoriesEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/inter-division-inventories?customerCode=${req.customerCode}&divisionGroup=${req.selectedDivisionGroup}`)
}
export function getDivisionInventoriesEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/division-inventories?customerCode=${req.customerCode}&divisionGroup=${req.selectedDivisionGroup}`)
}
export function getDivisionBalanceCheckEnquiry(req){
  return eHubApi.get(`/api/enquiry/v2/division-balance-check?divisionGroup=${encodeURIComponent(req.selectedDivisionGroup)}`)
}

export function getDivisionStockTransferEnquiry(req){
  return eHubApi.get(`/api/enquiry/division-stock-transfer?divisionGroup=${req.divisionGroup}&startDate=${req.startDate}&endDate=${req.endDate}`)
}